"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeSpanProcessor = exports.configureSpanProcessors = void 0;
const baggage_span_processor_1 = require("./baggage-span-processor");
const browser_attributes_span_processor_1 = require("./browser-attributes-span-processor");
const sdk_trace_base_1 = require("@opentelemetry/sdk-trace-base");
const http_json_trace_exporter_1 = require("./http-json-trace-exporter");
const composite_exporter_1 = require("./composite-exporter");
const console_trace_link_exporter_1 = require("./console-trace-link-exporter");
/**
 * Builds and returns Span Processor that combines the BatchSpanProcessor, BrowserSpanProcessor,
 * BaggageSpanProcessor, and optionally a user provided Span Processor.
 * @param options The {@link HoneycombOptions}
 * @returns a {@link CompositeSpanProcessor}
 */
const configureSpanProcessors = (options) => {
    const honeycombSpanProcessor = new CompositeSpanProcessor();
    const honeycombTraceExporters = [];
    if (options === null || options === void 0 ? void 0 : options.localVisualizations) {
        honeycombTraceExporters.push((0, console_trace_link_exporter_1.configureConsoleTraceLinkExporter)(options));
    }
    // if there is a user-provided exporter, add to the composite exporter
    if (options === null || options === void 0 ? void 0 : options.traceExporter) {
        honeycombTraceExporters.push(options === null || options === void 0 ? void 0 : options.traceExporter);
    }
    // We have to configure the exporter here because the way the base SDK is setup
    // does not allow having both a `spanProcessor` and `traceExporter` configured.
    honeycombSpanProcessor.addProcessor(new sdk_trace_base_1.BatchSpanProcessor((0, composite_exporter_1.configureCompositeExporter)([
        (0, http_json_trace_exporter_1.configureHoneycombHttpJsonTraceExporter)(options),
        ...honeycombTraceExporters,
    ])));
    // we always want to add the baggage span processor
    honeycombSpanProcessor.addProcessor(new baggage_span_processor_1.BaggageSpanProcessor());
    // we always want to add the browser attrs span processor
    honeycombSpanProcessor.addProcessor(new browser_attributes_span_processor_1.BrowserAttributesSpanProcessor());
    // if there is a user provided span processor, add it to the composite span processor
    if (options === null || options === void 0 ? void 0 : options.spanProcessor) {
        honeycombSpanProcessor.addProcessor(options === null || options === void 0 ? void 0 : options.spanProcessor);
    }
    return honeycombSpanProcessor;
};
exports.configureSpanProcessors = configureSpanProcessors;
/**
 * A {@link SpanProcessor} that combines multiple span processors into a single
 * span processor that can be passed into the SDKs `spanProcessor` option.
 */
class CompositeSpanProcessor {
    constructor() {
        this.spanProcessors = [];
    }
    addProcessor(processor) {
        this.spanProcessors.push(processor);
    }
    getSpanProcessors() {
        return this.spanProcessors;
    }
    onStart(span, parentContext) {
        this.spanProcessors.forEach((processor) => {
            processor.onStart(span, parentContext);
        });
    }
    onEnd(span) {
        this.spanProcessors.forEach((processor) => {
            processor.onEnd(span);
        });
    }
    forceFlush() {
        return Promise.all(this.spanProcessors.map((processor) => processor.forceFlush())).then(() => { });
    }
    shutdown() {
        return Promise.all(this.spanProcessors.map((processor) => processor.forceFlush())).then(() => { });
    }
}
exports.CompositeSpanProcessor = CompositeSpanProcessor;
